import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as fromActions from '../actions/settings.actions';
import { AumicoSettingsService } from '../services/aumico-settings.service';

@Injectable()
export class TranslationsEffects {
    constructor(private actions$: Actions, private service: AumicoSettingsService) {}

    getTranslations$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.translationsActions.getTranslations),
            mergeMap((action) => {
                return this.service.getTranslations(action.locales, action.untranslatedOnly).pipe(
                    map((response) => {
                        return fromActions.translationsActions.onGetTranslationsSuccess({
                            payload: response,
                        });
                    }),
                    catchError((error) => {
                        return of(fromActions.translationsActions.onGetTranslationsFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    updateTranslations$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.translationsActions.updateTranslations),
            mergeMap((action) => {
                const observable$ = this.service.updateTranslations(action.payload);
                return observable$.pipe(
                    map(() => {
                        return fromActions.translationsActions.onUpdateTranslationsSuccess();
                    }),
                    catchError((error) => {
                        return of(
                            fromActions.translationsActions.onUpdateTranslationsFailed({
                                payload: error,
                            }),
                        );
                    }),
                );
            }),
        ),
    );

    getSettingsTargetTranslations$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.translationsActions.getSettingsTargetTranslations),
            mergeMap((action) => {
                return this.service.getSettingsTargetTranslations(action.payload).pipe(
                    map((response) => {
                        return fromActions.translationsActions.onGetSettingsTargetTranslationsSuccess({
                            payload: response,
                        });
                    }),
                    catchError((error) => {
                        return of(
                            fromActions.translationsActions.onGetSettingsTargetTranslationsFailed({
                                payload: error,
                            }),
                        );
                    }),
                );
            }),
        ),
    );
}
